module.exports = __webpack_public_path__ + "static/img/qr-code-1.e7e2213.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qr-code-1.png
// module id = tLqS
// module chunks = 0